<template>
  <div>
    <DataTable
      :value="lstReportesLineas"
      v-model:expandedRows="expandedRows"
      dataKey="Id_reporte_linea"
      ref="dt"
      v-model:filters="filters"
      :globalFilterFields="[
        'Id_reporte_linea',
        'No_reportar',
        'Unidad',
        'Estatus',
        'Tipo_falla',
        'Folio_telmex',
        'Fecha_reporte',
        'Contacto',
        'No_contacto',
        'Folio_remedy',
        'Direccion_inmueble',
      ]"
      :loading="loading"
      :paginator="true"
      :rows="20"
      columnResizeMode="fit"
    >
      <template #header>
        <div class="flex align-items-center justify-content-between mb-3">
          <div class="table-header flex align-items-center gap-2">
            <h5>Equipos</h5>
            <span>Número de equipos {{ lstReportesLineas ? lstReportesLineas.length : 0 }}</span>
          </div>
          
          <div class="flex">
            <span class="p-input-icon-left mr-2">
              <i class="pi pi-search" />
              <InputText type="text" v-model="filters['global'].value" placeholder="Buscar..." />
            </span>
            
            <download-excel
                class="btn mr-2"
                :data="lstReportesLineas"
                :fields="fieldsExport"
                :stringifyLongNum="true"
                :name="'Reportes_lineas.xls'">
              <Button label="Exportar" icon="pi pi-external-link" class="p-button-warning mr-2"/>       
            </download-excel>
            <Button label="Nuevo" icon="pi pi-plus" class="p-button-success" @click="agregarDirectorio"/>
          </div>
        </div>
      </template>

      <template #empty> Aun no se encontraron registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>

        <Column :expander="true" headerStyle="width: 3rem" />
        <Column field="No_reportar" header="Número a reportar" sortable />
        <Column field="Unidad" header="Unidad" sortable />
        <Column field="Folio_telmex" header="Folio TELMEX" sortable />
        <Column field="Fecha_reporte" header="Fecha de reporte" sortable>
          <template #body="slotProps">
            {{ formatFechaReporte(slotProps.data.Fecha_reporte) }}
          </template>
        </Column>
        <Column field="Fecha_reporte" header="Días transcurridos" sortable>
          <template #body="slotProps">
            {{ diasTranscurridos(slotProps.data.Fecha_reporte) }}
          </template>
        </Column>
        <Column field="Tipo_falla" header="Tipo de falla" sortable />
        <Column field="Estatus" header="Estatus" sortable>
          <template #body="slotProps">
            <span :class="claseEstatus(slotProps.data.Estatus)">
              {{ slotProps.data.Estatus }}
            </span>
          </template>
        </Column>
        <Column :exportable="false" style="min-width: 8rem; text-align: center;">
            <template #body="slotProps">
                <div style="display: flex; justify-content: center; align-items: center; gap: 0.5rem;">
                    <Button
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-success"
                        @click="edit(slotProps.data)"
                        v-tooltip.top="'Editar'"
                    />
                    <Button
                        icon="pi pi-times"
                        class="p-button-rounded p-button-danger"
                        @click="borrar(slotProps.data)"
                        v-tooltip.top="'Eliminar'"
                    />
                </div>
            </template>
        </Column>

      <template #expansion="slotProps">
        <Card>
          <template #content>
            <div class="grid">
              <div class="col-6">
                <div class="grid">
                  <div class="col title">Contacto</div>
                  <div class="col data">{{ slotProps.data.Contacto }}</div>
                </div>
                <div class="grid">
                  <div class="col title">No. de contacto</div>
                  <div class="col data">{{ slotProps.data.No_contacto }}</div>
                </div>
              </div>

              <div class="col-6">
                <div class="grid">
                  <div class="col title">Folio remedy</div>
                  <div class="col data">{{ slotProps.data.Folio_remedy }}</div>
                </div>
                <div class="grid">
                  <div class="col title">Dirección inmueble</div>
                  <div class="col data">{{ slotProps.data.Direccion_inmueble }}</div>
                </div>
              </div>
            </div>
          </template>
        </Card>
      </template>

      <template #footer>
        Registros en total {{ lstReportesLineas ? lstReportesLineas.length : 0 }}
      </template>
    </DataTable>
  </div>

    <Dialog
      :style="{ width: '750px' }"
      :visible="showAgregar"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
        <template #header>
          <h3>{{ modoEdicion }} directorio</h3>
          </template>   

          <div class="p-formgrid grid">
            <div class="p-field col">
                <label for="unidad_select">Unidad</label>
                <Dropdown 
                    id="unidad_select"
                    appendTo="body"
                    v-model="directorioSeleccionado"
                    :filter="true" 
                    :options="lstUnidades"      
                    optionLabel="UNIDAD_SUBRED"  
                    placeholder="Seleccione una unidad"
                    @change="OnUnidadChange" 
                    :class="{'p-invalid': submitted && !directorioSeleccionado}"
                />
                <small class="p-invalid" v-if="submitted && !directorioSeleccionado">
                    La unidad es requerida.
                </small>
            </div>

    <div class="p-field col">
        <label for="linea_select">Línea a reportar</label>
        <Dropdown 
            id="linea_select"
            appendTo="body"
            v-model="ReporteLinea.No_reportar"
            :options="lstLineasAsociadas"
            optionLabel="Linea_telefonica"
            optionValue="Linea_telefonica"
            placeholder="Seleccione una línea"
            :disabled="!lstLineasAsociadas.length"
            :class="{'p-invalid': submitted && !ReporteLinea.No_reportar}"
        />
        <small v-if="directorioSeleccionado && lstLineasAsociadas.length === 0" style="color: orange;">
            Esta unidad no tiene líneas registradas.
        </small>
        <small class="p-invalid" v-if="submitted && !ReporteLinea.No_reportar">
            La línea es requerida.
        </small>
    </div>
</div>

          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="Direccion_inmueble">Dirección inmueble</label>
              <Textarea 
                  id="Direccion_inmueble"
                  v-model.trim="ReporteLinea.Direccion_inmueble" 
                  readonly
                  :autoResize="true" 
                  rows="1" 
                  style="width: 100%; resize: none;" 
                  placeholder="Dirección inmueble"
              />
            </div>

            <div class="p-field col">
              <label for="folio_remedy">Folio remedy</label>
              <InputText
                  autocomplete="off"
                  id="folio_remedy"
                  v-model.trim="ReporteLinea.Folio_remedy"
                  required="true"
                  autofocus
                  placeholder="Folio remedy"
              />
            </div>
          </div>

          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="ubicacion">Folio TELMEX</label>
              <InputText
                  autocomplete="off"
                  id="ubicacion"
                  v-model.trim="ReporteLinea.Folio_telmex"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !ReporteLinea.Folio_telmex }"
                  placeholder="Folio TELMEX"
              />
              <small style="color: red;" class="p-invalid" v-if="submitted && !ReporteLinea.Folio_telmex"
                  >El folio telmex es requerido.</small
              >
            </div>
            
            <div class="p-field col">
              <label for="ubicacion">Fecha de reporte</label>
              <Calendar
                  id="fecha_reporte"
                  v-model="ReporteLinea.Fecha_reporte"
                  date-format="dd/mm/yy"
                  show-icon
                  :class="{ 'p-invalid': submitted && !ReporteLinea.Fecha_reporte }"
                  placeholder="Fecha de reporte"
              />
              <small style="color: red;" class="p-invalid" v-if="submitted && !ReporteLinea.Fecha_reporte"
                  >La fecha de reporte es requerida.</small
              >
            </div>

            <div class="p-field col">
              <label for="unidad">Estatus</label>
              <Dropdown
                id="estatus"
                appendTo="body"
                v-model="ReporteLinea.Id_estatus"
                :options="lstEstatus"
                optionLabel="Descripcion" 
                optionValue="Id_estatus"
                placeholder="Selecciona un estatus"
                :class="{'p-invalid': submitted && !ReporteLinea.Id_estatus}"
              />
              <small style="color: red;" class="p-invalid" v-if="submitted && !ReporteLinea.Id_estatus">
                  El estatus es requerida.
              </small>  
            </div>
          </div>

          <div class="p-formgrid grid">
            <div class="p-field col">
              <label for="Tipo_de_falla">Tipo de falla</label>
              <Dropdown
                id="Tipo_de_falla"
                appendTo="body"
                v-model="ReporteLinea.Id_tipo_falla"
                :options="lstTiposFallos"
                optionLabel="Descripcion" 
                optionValue="Id_tipo_fallo"
                placeholder="Selecciona un Tipo de Falla"
                :class="{'p-invalid': submitted && !ReporteLinea.Id_tipo_falla}"
              Dropdown/>
              <small style="color: red;" class="p-invalid" v-if="submitted && !ReporteLinea.Id_tipo_falla">
                  El regimen es requerida.
              </small>  
            </div>
            
            <div class="p-field col">
              <label for="contacto">Contacto</label>
              <InputText
                id="contacto"
                v-model="ReporteLinea.Contacto"
                readonly
                placeholder="Contacto"
              />

            </div>

            <div class="p-field col">
              <label for="no_contacto">Número de contacto</label>
              <InputText
                  autocomplete="off"
                  id="no_contacto"
                  v-model.trim="ReporteLinea.No_contacto"
                  required="true"
                  autofocus
                  readonly
                  placeholder="Número de contacto"
                  @keypress="soloNumeros($event)"
                  @keydown="bloquearSiLleno($event, 10)"
              />
            </div>
          </div>
        <template #footer>
        <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text"
            @click="cancelarDialogo"
        />
        <Button
            label="Guardar"
            icon="pi pi-check"
            class="p-button-text"
            @click="guardarDirectorio"
        />
        </template>
    </Dialog>

    <ConfirmDialog></ConfirmDialog>

</template>

<script>
import Srvr from "../service/DirectorioUnidad";
import SrvrRep from "../service/Reportes_lineas";
import SrvrU from "../service/Inventario";
import SrvrRef from "../service/Referencias";
import { ConfirmDialog } from 'primevue/confirmdialog';

export default {
    components: {
      ConfirmDialog
    },
  data() {
    return {
      lstLineasAsociadas: [],
      lstUnidades: [],
      lstContactos: [],
      referenciasFiltradas: [],
      lstEstatus: [],
      lstTiposFallos: [],
      lstVacia: [],
      lstReportesLineas: [],
      reportesLineasFiltradas: [],
      lstDirectoriosUnidades: [],
      expandedRows: [],
      submitted: false,
      errorNoContacto: false,
      errorNoReportar: false,
      filters: {
      global: { value: null, matchMode: 'contains' },
      },
      loading: false,
      showAgregar: false,
      modoEdicion: '',
      ReporteLinea: {
        Id_reporte_linea: null,
        Id_estatus: null,
        Id_tipo_falla: null,
        Subred_unidad: '',
        No_reportar: '',
        Unidad: '',
        Estatus: '',
        Tipo_falla: '',
        Folio_telmex: '',
        Fecha_reporte: new Date(), // CORRECCIÓN 1: Objeto Date, no string
        Contacto: '',
        No_contacto: '',
        Folio_remedy: '',
        Direccion_inmueble: '',
      },
      directorioSeleccionado: null,
      fieldsExport: {
        No_reportar: "No_reportar",
        Unidad: "Unidad",
        Folio_telmex: "Folio_telmex",
        Fecha_reporte: {
          field: "Fecha_reporte",
          callback: (value) => {
            if (!value) return "";
            const match = /Date\((\d+)\)/.exec(value);
            if (!match) return value;
            const date = new Date(parseInt(match[1], 10));
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
          }
        },
        Dias_transcurridos: {
          field: "Fecha_reporte",
          callback: (value) => {
            if (!value) return "";
            const match = /Date\((\d+)\)/.exec(value);
            if (!match) return value;
            const date = new Date(parseInt(match[1], 10));
            const today = new Date();
            const diffTime = Math.abs(today - date);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays - 1;
          }
        },
        Tipo_falla: 'Tipo_falla',
        Estatus: 'Estatus',
        Contacto: 'Contacto',
        Folio_remedy: 'Folio_remedy',
        No_contacto: 'No_contacto',
        Direccion_inmueble: 'Direccion_inmueble',
      },
    };
  },
  computed: {
    filtroDirectorios() {
      if (!this.lstDirectoriosUnidades) {
        return [];
      }
      return this.lstDirectoriosUnidades.map(item => {
        return {
          ...item, 
          Display_Label: `${item.Linea_telefonica} - ${item.Unidad}`
        };
      });
    }
  },
  mounted() {
    this.cargaInicial();

  },
  methods: {
    cargaInicial() {
      const t = this;
      const ctlSvr = new SrvrRep();
      t.loading = true;

      ctlSvr.getReportesLineas(t).then((res) => {
        t.lstReportesLineas = res
        t.loading = false;
      });
    },
    expandAll() {
        this.expandedRows = {};
        this.lstReportesLineas.forEach(item => {
        this.expandedRows[item.Id_reporte_linea] = true;
      });
    },
    collapseAll() {
      this.expandedRows = {};
    },
    agregarDirectorio() {
      this.modoEdicion = 'Agregar';
      this.directorioSeleccionado = null,
      this.submitted = false;
      this.loading = true;
    
      const ctlSvrU = new SrvrU();
      const ctlSvr = new Srvr();
      const ctlSvrRep = new SrvrRep();
      const ctlSvrRef = new SrvrRef();
      const ctlSvrDU = new Srvr(); 

    
      const promesas = [
        ctlSvrU.getUnidades(this),
        ctlSvr.getEstatusActivos(this),
        ctlSvrRep.getTiposFallos(this),
        ctlSvrRef.getReferencias(this),
        ctlSvrDU.getDirectoriosUnidades(this),
      ];
    
      Promise.all(promesas)
        .then((resultados) => {
          this.lstUnidades = resultados[0];
          this.lstEstatus = resultados[1];
          this.lstTiposFallos = resultados[2];
          this.lstContactos = resultados[3];
          this.lstDirectoriosUnidades = resultados[4];

          this.lstVacia = this.filtroDirectorios;

          // Filtra referencias por la subred seleccionada (si existe)
          if (this.ReporteLinea.Subred_unidad) {
            this.referenciasFiltradas = this.lstReferencias.filter(
              referencia => referencia.Segmento === this.ReporteLinea.Subred_unidad
            );
          } else {
            this.referenciasFiltradas = [];
          }
          // Asigna el primer responsable si existe
          this.ReporteLinea.Responsable = this.referenciasFiltradas.length > 0
            ? this.referenciasFiltradas[0].Responsable
            : '';

          this.loading = false;
          this.showAgregar = true;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error al cargar listas:", error);
        });

      // CORRECCIÓN 2: Inicializar con Date Object, no string formateado
      this.ReporteLinea.Fecha_reporte = new Date();
    },
    cancelarDialogo(){
        this.showAgregar = false;
        this.modoEdicion = '';
        this.ReporteLinea = {
          Id_reporte_linea: null,
          Id_unidad: null,
          Id_estatus: null,
          Id_tipo_falla: null,
          No_reportar: '',
          Unidad: '',
          Estatus: '',
          Tipo_falla: '',
          Folio_telmex: '',
          Fecha_reporte: '',
          Contacto: '',
          No_contacto: '',
          Folio_remedy: '',
          Direccion_inmueble: '',
        };
    },
    guardarDirectorio() {
        const ctlSvr = new SrvrRep();
        this.submitted = true;

        if (
            !this.directorioSeleccionado || 
            !this.ReporteLinea.Folio_telmex || 
            !this.ReporteLinea.Id_estatus || 
            !this.ReporteLinea.Id_tipo_falla
        ) {
            this.$toast.add({ 
                severity: 'error', 
                summary: 'Error de Validación', 
                detail: 'Faltan campos obligatorios', 
                life: 4000 
            });
            return;
        }

        this.errorNoContacto = !this.esTelefonoValido(this.ReporteLinea.No_contacto);
        this.errorNoReportar = !this.esTelefonoValido(this.ReporteLinea.No_reportar);

        // Asignar datos de la Unidad desde el Dropdown seleccionado
        if (this.directorioSeleccionado) {
            this.ReporteLinea.Unidad = this.directorioSeleccionado.UNIDAD;
            this.ReporteLinea.Subred_unidad = this.directorioSeleccionado.SUBRED;
        }

        // Llenar descripción de Estatus
        const estatusSeleccionado = this.lstEstatus.find(e => e.Id_estatus === this.ReporteLinea.Id_estatus);
        this.ReporteLinea.Estatus = estatusSeleccionado ? estatusSeleccionado.Descripcion : '';

        // Llenar descripción de Tipo Falla
        const tipoFallaSeleccionada = this.lstTiposFallos.find(tr => tr.Id_tipo_fallo === this.ReporteLinea.Id_tipo_falla);
        this.ReporteLinea.Tipo_falla = tipoFallaSeleccionada ? tipoFallaSeleccionada.Descripcion : '';

        if (this.ReporteLinea.Responsable === '') {
            delete this.ReporteLinea.Responsable;
        }

        // Creaa la copia UNA sola vez aquí para usarla tanto en Add como en Update
        const payload = { ...this.ReporteLinea };

        // convertimos la fecha SOLO en la copia (payload)
        payload.Fecha_reporte = this.convertirFechaDotNet(this.ReporteLinea.Fecha_reporte);

        // ENVIAR AL SERVIDOR
        if (this.ReporteLinea.Id_reporte_linea) {
            // ACTUALIZAR
            ctlSvr.Update(this, payload).then(() => {
                this.$toast.add({
                    severity: "success",
                    summary: "AVISO",
                    detail: "Directorio actualizado correctamente",
                    life: 3000,
                });
                this.cancelarDialogo();
                this.cargaInicial();
            });
        } else {
            // AGREGAR
            delete payload.Id_reporte_linea;

            ctlSvr.Add(this, payload).then(() => {
                this.$toast.add({
                    severity: "success",
                    summary: "AVISO",
                    detail: "Directorio agregado correctamente",
                    life: 3000,
                });
                this.cancelarDialogo();
                this.cargaInicial();
            });
        }
    },
    edit(obj){
    const ctlSvrU = new SrvrU();
    const ctlSvr = new Srvr();
    const ctlSvrRep = new SrvrRep();
    const ctlSvrDU = new Srvr(); 

    this.ReporteLinea = { ...obj };
    this.modoEdicion = 'Editar';
    this.showAgregar = true;

    // fecha .NET
    if (this.ReporteLinea.Fecha_reporte && /\/Date\((\d+)\)\//.test(this.ReporteLinea.Fecha_reporte)) {
        const match = /\/Date\((\d+)\)\//.exec(this.ReporteLinea.Fecha_reporte);
        this.ReporteLinea.Fecha_reporte = match ? new Date(parseInt(match[1], 10)) : '';
    }

    // Se usa PROMISE.ALL para cargar Unidades y Directorios al mismo tiempo
    Promise.all([
        ctlSvrU.getUnidades(this),            
        ctlSvrDU.getDirectoriosUnidades(this) 
    ]).then((resultados) => {

        this.lstUnidades = resultados[0];
        this.lstDirectoriosUnidades = resultados[1];
        
        // Busca la unidad
        const unidadEncontrada = this.lstUnidades.find(
            unidad => unidad.UNIDAD === obj.Unidad
        );

        if (unidadEncontrada) {
            this.directorioSeleccionado = unidadEncontrada;
            this.ReporteLinea.Subred_unidad = unidadEncontrada.SUBRED;
            
            if(!this.ReporteLinea.Direccion_inmueble){
                 this.ReporteLinea.Direccion_inmueble = unidadEncontrada.Direccion || '';
            }
            if (this.lstDirectoriosUnidades) {
                if (unidadEncontrada.Id_unidad) {
                    this.lstLineasAsociadas = this.lstDirectoriosUnidades.filter(
                        linea => linea.Id_unidad == unidadEncontrada.Id_unidad
                    );
                } 
                // (Si el ID falla, filtramos por Nombre)
                if (this.lstLineasAsociadas.length === 0 && unidadEncontrada.UNIDAD) {
                    this.lstLineasAsociadas = this.lstDirectoriosUnidades.filter(
                        linea => linea.Unidad === unidadEncontrada.UNIDAD
                    );
                }
            }
        }
        this.loading = false;
    });

    // Carga de Estatus 
    ctlSvr.getEstatusActivos(this).then((res) => {
        this.lstEstatus = res;
        if (this.ReporteLinea.Id_estatus && !this.lstEstatus.some(e => e.Id_estatus === this.ReporteLinea.Id_estatus)) {
            this.lstEstatus.push({ Id_estatus: this.ReporteLinea.Id_estatus, Descripcion: this.ReporteLinea.Estatus });
        }
    });

    // Carga de Tipos de Falla 
    ctlSvrRep.getTiposFallos(this).then((res) => {
        this.lstTiposFallos = res;
        if (this.ReporteLinea.Id_tipo_falla && !this.lstTiposFallos.some(e => e.Id_tipo_fallo === this.ReporteLinea.Id_tipo_falla)) {
            this.lstTiposFallos.push({ Id_tipo_fallo: this.ReporteLinea.Id_tipo_falla, Descripcion: this.ReporteLinea.Tipo_falla });
        }
    });
},
    borrar(obj) {
      var t = this;      
      t.$confirm.require({
        message: '¿Quiere desactivar el reporte?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sí, eliminar',
        rejectLabel: 'Cancelar',
        acceptClass: 'p-button-danger',
        accept: () => {
          const ctlSvr = new SrvrRep();
          ctlSvr.Delete(t, obj.Id_reporte_linea).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Directorio se elimino correctamente",
              life: 3000,
            });
            t.cargaInicial();
          });
        },
        reject: () => {
          // Usuario canceló
        }
      });
    },
    soloNumeros(event) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    bloquearSiLleno(event, maxLength) {
      const teclasPermitidas = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
      if (teclasPermitidas.includes(event.key)) return;

      if (event.target.id === 'no_reportar' && this.ReporteLinea.No_reportar?.length >= maxLength) {
        event.preventDefault();
      }

      if (event.target.id === 'no_contacto' && this.ReporteLinea.No_contacto?.length >= maxLength) {
        event.preventDefault();
      }
    },
    esTelefonoValido(telefono) {
      return /^\d{10}$/.test(telefono);
    },
    formatFechaReporte(fecha) {
    if (!fecha) return '';
    
    // Detectar formato de .NET (fechas negativas o año 0)
    if (typeof fecha === 'string' && fecha.includes('/Date(-')) {
        return ''; 
    }

    const match = /\/Date\((\d+)\)\//.exec(fecha);
    if (!match) return fecha; // Si ya es texto normal, lo regresa

    const date = new Date(parseInt(match[1], 10));
    
    // Si el año es menor a 2000 es error
    if (date.getFullYear() < 2000) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
},
    convertirFechaDotNet(fecha) {
      if (!fecha) return '';
      if (/\/Date\(\d+\)\//.test(fecha)) return fecha;
      let dateObj = typeof fecha === 'string' ? new Date(fecha) : fecha;
      if (isNaN(dateObj.getTime())) return '';
      return `/Date(${dateObj.getTime()})/`;
    },
    filtrarReferencias() {
      if (!this.lstContactos || !Array.isArray(this.lstContactos)) {
        try {
            this.lstContactos = JSON.parse(this.lstContactos);
        } catch(e) { this.lstContactos = []; }
      }
      
      if (this.ReporteLinea.Subred_unidad) {
        this.referenciasFiltradas = this.lstContactos.filter(
          referencia => referencia.Segmento.trim() === this.ReporteLinea.Subred_unidad.trim()
        );
      } else {
        this.referenciasFiltradas = [];
      }
    
      if (this.referenciasFiltradas.length > 0) {
        this.ReporteLinea.Contacto = this.referenciasFiltradas[0].Responsable || '';
        this.ReporteLinea.No_contacto = this.referenciasFiltradas[0].Contacto || '';
      } else {
        this.ReporteLinea.Contacto = '';
        this.ReporteLinea.No_contacto = '';
      }
    },
    diasTranscurridos(fecha) {
      if (!fecha) return '';
      const match = /\/Date\((\d+)\)\//.exec(fecha);
      if (!match) return '';
      const fechaReporte = new Date(parseInt(match[1], 10));
      const hoy = new Date();
      // Solo fecha, sin hora
      hoy.setHours(0,0,0,0);
      fechaReporte.setHours(0,0,0,0);
      const diffMs = hoy - fechaReporte;
      const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      return diffDias >= 0 ? diffDias : 0;
    },
    claseEstatus(estatus) {
      const clases = {
        'Activa': 'estatus-activa',
        'Lista': 'estatus-lista',
        'Reportada': 'estatus-reportada',
        'Dañada': 'estatus-danada',
        'No contestan': 'estatus-no-contestan'
      };
      return clases[estatus] || '';
    },
    OnUnidadChange(event){
    const unidadSeleccionada = event.value;

    this.ReporteLinea.No_reportar = ''; 
    this.lstLineasAsociadas = [];

    if (unidadSeleccionada) {
        this.ReporteLinea.Unidad = unidadSeleccionada.UNIDAD;
        this.ReporteLinea.Subred_unidad = unidadSeleccionada.SUBRED;
        this.ReporteLinea.Direccion_inmueble = unidadSeleccionada.Direccion || '';

        // FILTRO ROBUSTO
        if (this.lstDirectoriosUnidades) {
            // Por ID
            if (unidadSeleccionada.Id_unidad) {
                this.lstLineasAsociadas = this.lstDirectoriosUnidades.filter(
                    linea => linea.Id_unidad == unidadSeleccionada.Id_unidad
                );
            }
            // Por Nombre (Si falló el ID)
            if (this.lstLineasAsociadas.length === 0) {
                 this.lstLineasAsociadas = this.lstDirectoriosUnidades.filter(
                    linea => linea.Unidad === unidadSeleccionada.UNIDAD
                );
            }
        }

        this.filtrarReferencias();

    } else {
        this.ReporteLinea.Unidad = '';
        this.ReporteLinea.Direccion_inmueble = '';
        this.ReporteLinea.Subred_unidad = '';
        this.ReporteLinea.Contacto = '';
        this.ReporteLinea.No_contacto = '';
    }
},
  },
};
</script>

<style scoped>
.estatus-activa,
.estatus-lista {
  background-color: #d0f8ce;
  color: #2e7d32;
  border-radius: 2px;
  padding: .25em .5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .3px;
}

.estatus-reportada {
  background-color: #fff9c4;
  color: #fbc02d;
  border-radius: 2px;
  padding: .25em .5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .3px;
}

.estatus-danada,
.estatus-no-contestan {
  background-color: #ffcdd2;
  color: #c63737;
  border-radius: 2px;
  padding: .25em .5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .3px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-header-container {
  display: flex;
  margin-bottom: 10px;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.5px;
  margin-right: 10px;
}
</style>